var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SentimentUpLimit'),_c('SentimentZhaban'),_c('v-chart',{attrs:{"options":_vm.polar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }